import React from "react";

const Success = () => {
  return (
    <>
      <div className="tf-page-title style-2">
        <div className="container-full">
          <div className="heading text-center">SUCCESS</div>
        </div>
      </div>
      <section className="flat-spacing-25">
        <div className="container">
          <div className="tf-main-area-page success">
            <div className="text-center pb-lg-17 pb-13 mb-3">
              <h2> Thank you for your Order</h2>
              <div className="row">
                <div className="col-sm-12 col-xs-12 text-center">
                  <p>
                    Ordered Date:
                    <strong>06-12-2024, 10:22 PM</strong>
                  </p>
                  <p>
                    DELIVERY TIME: <strong>7-10 Days</strong>
                  </p>
                  <p>
                    Order Id: <strong>#62</strong>
                  </p>
                </div>
                <hr />
                <div className="col-sm-12 col-xs-12">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th>Quantity</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="pe-5 ps-8 py-7">
                          <div className="d-flex align-items-center">
                            <div className="ms-6 me-7">
                              <img
                                src="https://imgcdn.webykw.com/cdn-cgi/image/fit=cover,width=75,height=100/lolia/products/1726330315_b964d4dba25069fb.jpg"
                                width="75"
                                height="100"
                                alt="V-Neck Cardigan"
                              />
                            </div>
                            <div className="ms-3">
                              <p>
                                V-Neck Cardigan
                                <br />
                                Color: Off-White
                                <br />
                                Size: XS
                                <br />
                                Add Length Details: 1
                              </p>
                            </div>
                          </div>
                        </td>
                        <td className="align-middle">
                          <p className="mb-0">1</p>
                        </td>
                        <td className="align-middle">
                          <p className="mb-0">KWD 10.410</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="table table-summary">
                    <tbody>
                      <tr className="summary-subtotal">
                        <td colspan="3">Sub Total:</td>
                        <td>KWD 10.410</td>
                      </tr>
                      <tr className="summary-shipping">
                        <td colspan="3">Discount:</td>
                        <td>KWD 0.000</td>
                      </tr>
                      <tr className="summary-shipping">
                        <td colspan="3">Delivery Charges:</td>
                        <td>KWD 2.500</td>
                      </tr>
                      <tr className="summary-total">
                        <td colspan="3">Grand Total:</td>
                        <td>KWD 12.910</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-sm-12 col-xs-12 text-center">
                  <a
                    href="https://uat.webykw.com/"
                    className="btn btn-dark btn-hover-bg-primary btn-hover-border-primary px-11 mt-md-7 mt-4"
                  >
                    CONTINUE SHOPPING
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Success;
